/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Nochangelog2Inputs */

const id_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada changelog tersedia`)
};

const ms_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada changelog tersedia`)
};

const da_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ændringslog tilgængelig`)
};

const de_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Änderungsprotokoll verfügbar`)
};

const en_us2_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changelog available`)
};

const es_es2_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay registro de cambios disponible`)
};

const es_mx2_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay registro de cambios disponible`)
};

const fil_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang available na talaan ng pagbabago`)
};

const fr_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun journal des modifications disponible`)
};

const it_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun registro modifiche disponibile`)
};

const hu_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem elérhető változásnapló`)
};

const nl_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen wijzigingslogboek beschikbaar`)
};

const no_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen endringslogg tilgjengelig`)
};

const pl_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak dziennika zmian`)
};

const pt_br2_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registro de alterações disponível`)
};

const pt_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registo de alterações disponível`)
};

const ro_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niciun jurnal de modificări disponibil`)
};

const fi_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutoslokia ei saatavilla`)
};

const sv_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ändringslogg tillgänglig`)
};

const vi_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có nhật ký thay đổi`)
};

const tr_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik günlüğü mevcut değil`)
};

const cs_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný seznam změn není k dispozici`)
};

const bg_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма наличен дневник на промените`)
};

const ru_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений недоступен`)
};

const uk_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін недоступний`)
};

const ar_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد سجل تغييرات متاح`)
};

const hi_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई बदलाव लॉग उपलब्ध नहीं`)
};

const th_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีบันทึกการเปลี่ยนแปลง`)
};

const ja_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能な更新履歴はありません`)
};

const zh_cn2_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无可用更新日志`)
};

const zh_hant1_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無可用更新日誌`)
};

const ko_offerdetail_changelog_nochangelog2 = /** @type {(inputs: Offerdetail_Changelog_Nochangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역을 사용할 수 없음`)
};

/**
* | output |
* | --- |
* | "No changelog available" |
*
* @param {Offerdetail_Changelog_Nochangelog2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_nochangelog2 = /** @type {((inputs?: Offerdetail_Changelog_Nochangelog2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Nochangelog2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "da") return da_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "de") return de_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "it") return it_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "no") return no_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "th") return th_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_nochangelog2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_nochangelog2(inputs)
	return ko_offerdetail_changelog_nochangelog2(inputs)
});
export { offerdetail_changelog_nochangelog2 as "offerDetail.changelog.noChangelog" }